
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4">おかやま建築設計事務所</h3>
            <p className="text-gray-300 mb-4">
              岡山市・倉敷市を中心に、住宅・店舗・公共施設などの建築設計・監理を行う一級建築士事務所です。
              機能美と快適性を追求した設計をご提案します。
            </p>
            <div className="flex space-x-4">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-line text-blue-400"></i>
              </div>
              <span className="text-gray-300">086-012-3456</span>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">サービス</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-white transition-colors cursor-pointer">住宅設計</Link></li>
              <li><Link to="/" className="text-gray-300 hover:text-white transition-colors cursor-pointer">商業施設設計</Link></li>
              <li><Link to="/" className="text-gray-300 hover:text-white transition-colors cursor-pointer">公共建築設計</Link></li>
              <li><Link to="/" className="text-gray-300 hover:text-white transition-colors cursor-pointer">リノベーション</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">会社情報</h4>
            <ul className="space-y-2">
              <li><Link to="/company" className="text-gray-300 hover:text-white transition-colors cursor-pointer">会社概要</Link></li>
              <li><Link to="/careers" className="text-gray-300 hover:text-white transition-colors cursor-pointer">求人情報</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-white transition-colors cursor-pointer">ブログ</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} おかやま建築設計事務所. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer mt-2 sm:mt-0"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
};
